import React, { type ReactNode } from 'react';
import { Box, Flex } from '@chakra-ui/react';
import { FormattedMessage } from 'react-intl';
import { Text } from '../../../../../ui-components';

interface BopisLocationSelectorProps {
    bopisSddFontSize: 'small' | 'base';
    bopisStoreName?: string;
    isBopisSelected: boolean;
    isFetchingBopisStore: boolean;
    isBopisStoreEligibleOrNull: boolean | undefined;
    bopisStoreComponent: (chunks: ReactNode[]) => React.ReactElement;
}

export const BopisLocationSelector: React.FC<BopisLocationSelectorProps> = ({
    bopisSddFontSize,
    bopisStoreName,
    isBopisSelected,
    isFetchingBopisStore,
    isBopisStoreEligibleOrNull,
    bopisStoreComponent,
}) => {
    if (!isBopisSelected || isFetchingBopisStore) {
        return null;
    }

    if (isBopisStoreEligibleOrNull) {
        return (
            <Text id="search-filters-bopis-store-label" size={bopisSddFontSize} style="bold">
                <FormattedMessage
                    id="store.pick.up.at.with.component"
                    defaultMessage="Pick up at <storeComponent>{store}</storeComponent>"
                    values={{
                        storeComponent: bopisStoreComponent,
                        store: bopisStoreName ?? 'Choose Location',
                    }}
                />
            </Text>
        );
    }

    return (
        <Flex data-testid="search-filters-bopis-container">
            <Text id="search-filters-bopis-store-not-available" size={bopisSddFontSize}>
                <FormattedMessage
                    id="bopis.not.available.in"
                    defaultMessage="Pick up not available in {store}"
                    values={{
                        store: (
                            <>
                                <Box as="br" display={{ base: 'block', sm: 'none' }} />
                                {bopisStoreComponent([bopisStoreName ?? 'Choose Location'])}
                            </>
                        ),
                    }}
                />
            </Text>
        </Flex>
    );
};
